<div
	class="badge-container frow-center-center"
	[ngClass]="{ available: value > 2, warning: value <= 2 && value > 0, unavailable: value <= 0 }"
>
	<span class="badge-value">{{ value }}</span>
</div>
